import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mdiMagnifyRemoveOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import grey from '@mui/material/colors/grey';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { isEmptyFilter } from '../../filter/helpers';
import { defineStyles } from '../../theme';
import { useSTRowFilterCondition, useSTRows } from '../SmartTableContext';
const styles = defineStyles({
    overlay: {
        marginTop: 6,
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: 'background.paper',
        opacity: 0,
        animation: 'emptyRowsFadeIn 0.2s ease-in 0.5s forwards',
        '@keyframes emptyRowsFadeIn': {
            to: { opacity: 1 },
        },
    },
    iconCircle: {
        width: 72,
        height: 72,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: grey[500],
    },
});
export function EmptyRows() {
    const [filters] = useSTRowFilterCondition();
    const { rowsCount, rowsLoading } = useSTRows();
    const isEmpty = rowsCount === 0 && !rowsLoading;
    const hasActiveFilters = useMemo(() => !isEmptyFilter(filters ?? null), [filters]);
    if (!isEmpty || !hasActiveFilters)
        return null;
    return (_jsxs(Box, { sx: styles.overlay, "data-testid": "empty-rows", children: [_jsx(Box, { sx: styles.iconCircle, children: _jsx(Icon, { path: mdiMagnifyRemoveOutline, size: 2.5 }) }), _jsx(Typography, { variant: "h6", component: "h2", fontWeight: "bold", color: "text.primary", children: _jsx(FormattedMessage, { id: "table.empty.noData", defaultMessage: "\u017D\u00E1dn\u00E9 z\u00E1znamy k zobrazen\u00ED" }) }), _jsx(Typography, { variant: "body2", color: "text.secondary", textAlign: "center", children: _jsx(FormattedMessage, { id: "table.empty.noResultsDescription", defaultMessage: "Aktu\u00E1ln\u00ED filtr neodpov\u00EDd\u00E1 \u017E\u00E1dn\u00FDm z\u00E1znam\u016Fm. Zkuste upravit nebo vymazat filtry." }) })] }));
}
//# sourceMappingURL=EmptyRows.js.map